import { Stack, XStack, YStack } from '@my/ui'
import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { AdCarouselItem } from './ad-carousel-item'
import { AdCarouselProps } from './ad-carousel-props'

export const AdCarousel = ({ items, ...props }: AdCarouselProps) => {
  const [emblaRef] = useEmblaCarousel(
    {
      active: true,
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
      skipSnaps: true,
      align: 'start',
    },
    [WheelGesturesPlugin()]
  )
  return (
    <YStack bg="$white" br="$3" pb="$3.5" {...props}>
      <YStack px="$3.5" pb="$3.5" overflow="hidden">
        <Stack position="relative" className="overflow-x-hidden" ref={emblaRef as any}>
          <XStack gap="$3.5" height="auto">
            {items.map((item) => (
              <Stack
                key={item.id}
                flexGrow={1}
                width={200}
                $gtSm={{
                  width: 288,
                }}
              >
                <AdCarouselItem flex={1} {...item} />
              </Stack>
            ))}
          </XStack>
        </Stack>
      </YStack>
    </YStack>
  )
}
